import { i18nFilter } from "app/filters/i18nFilter";

import { generateListItems, generateTitle, getUSDPrice } from "../packageDataHelpers";
import type { IPackagesPrice } from "../types";
import { CIPackageId, SEOPackageId } from "../types";

import { COMP_INTEL_FEATURE_COUNT, COMP_INTEL_SEO_FEATURE_COUNT, TRANSLATION_KEYS } from "./constants";

export { getUSDPrice } from "../packageDataHelpers";

interface IPackageItem {
    title: string;
    subtitle: string;
    packageId: string;
    price: string;
    recommendedTag?: boolean;
    list: Array<{ item: string }>;
}

export const getPackagesData = (packages?: IPackagesPrice): IPackageItem[] => {
    const translate = i18nFilter();

    return [
        {
            title: generateTitle([TRANSLATION_KEYS.compIntelTitle]),
            subtitle: translate(TRANSLATION_KEYS.compIntelSubtitle),
            packageId: CIPackageId,
            price: packages ? getUSDPrice(packages.CompetitiveIntelligenceAnnually) : "0",
            list: generateListItems(COMP_INTEL_FEATURE_COUNT, TRANSLATION_KEYS.compIntelItems),
        },
        {
            title: generateTitle([
                TRANSLATION_KEYS.compIntelTitle,
                TRANSLATION_KEYS.compIntelSeoTitleSuffix,
                TRANSLATION_KEYS.compIntelAeoTitleSuffix,
            ]),
            subtitle: translate(TRANSLATION_KEYS.compIntelSeoSubtitle),
            packageId: SEOPackageId,
            recommendedTag: true,
            price: packages ? getUSDPrice(packages.CompetitiveIntelligenceSEOAnnually) : "0",
            list: generateListItems(COMP_INTEL_SEO_FEATURE_COUNT, TRANSLATION_KEYS.compIntelSeoItems),
        },
    ];
};
